import React from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";
import SectionContainer from "../../../../components/sectionContainer/sectionContainer";

const TotalPastDues = ({ qa }) => {
  const { displayPastDues, totalPastDues, totalPastDuesLink } = useSelector(
    (state) => state.membershipUnits.membershipUnits.totalPastDues
  );

  return displayPastDues ? (
    <div className="content__el">
      <SectionContainer title="Total Past Dues">
        <DataDisplay
          type="number"
          value={totalPastDues}
          url={totalPastDuesLink}
          disableAnimation={qa}
        />
      </SectionContainer>
    </div>
  ) : null;
};

export default TotalPastDues;
